<template>
  <v-container fluid>
    <h1 class="text-h4 mb-4">
      Blocked Recipients
    </h1>

    <v-card class="mb-4">
      <v-simple-table>
        <thead>
        <tr>
          <th>
            Value
          </th>
          <th>
            Type
          </th>
          <th>
            Weight
          </th>
          <th>
            Actions
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="recipient in recipients"
            :key="recipient.id">
          <td>
            {{ recipient.address }}
          </td>
          <td>
            {{ recipient.type }}
          </td>
          <td>
            {{ recipient.weight }}
          </td>
          <td>
            <v-btn @click.prevent="deleteRecipient(recipient)"
                   icon>
              <v-icon>
                fal fa-trash
              </v-icon>
            </v-btn>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </v-card>

    <v-form ref="form"
            @submit.prevent="submit"
            :disabled="form.busy">
      <v-card class="mb-4">
        <v-card-text>
          <v-radio-group v-model="form.type">
            <v-radio v-for="type in types"
                     :key="type.id"
                     :value="type.id"
                     :label="type.name">
            </v-radio>
          </v-radio-group>

          <v-text-field v-model="form.address"
                        :label="placeholder"
                        :rules="[rules.required]"
                        :error-messages="form.errors.get('address')"
                        required>
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary">
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import blockedRecipientService from '../../services/blockedRecipientService';
import {formValidation} from '../../plugins';

export default {
  mixins: [formValidation],
  data() {
    return {
      form: new Form({
        address: '',
        type: 'domain',
      }),
      recipients: [],
      types: [
        {id: 'address', name: 'Email address'},
        {id: 'domain', name: 'Domain'},
        {id: 'pattern', name: 'Pattern'},
      ],
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    placeholder() {
      switch (this.form.type) {
        case 'address':
          return 'Email address';
        case 'domain':
          return 'Domain';
        case 'pattern':
          return 'Regular expression';
        default:
          return 'Value';
      }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      blockedRecipientService.getBlockedRecipients()
        .then(data => {
          this.recipients = data;
        })
    },
    reset() {
      this.resetForm();
    },
    submit() {
      if (this.form.busy) {
        return;
      }
      this.form.post(`/api/blocked-recipients`)
        .then(() => {
          this.fetchData();
        })
    },
    deleteRecipient(recipient) {
      blockedRecipientService.deleteRecipient(recipient.id)
        .then(() => {
          this.fetchData();
        })
    }
  }
}
</script>
